import { AutogenLayoutIntBillCommentsQuickInfo } from "./autogen/AutogenLayoutIntBillCommentsQuickInfo";

export class IntBillCommentsQuickInfo extends AutogenLayoutIntBillCommentsQuickInfo {

}

